import React, { MouseEvent } from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box, IconButton, Paper, Typography } from '@mui/material';

import { Experiences } from '@luxuryescapes/contract-svc-experience';

import { currencyFormatter } from '~/components/Experiences/helpers/currancy-formatter';

interface SortableListItemProps {
  value: Experiences.Offer;
  removeOnclick: (value: Experiences.Offer) => void;
}

export function CuratedListItem({ value, removeOnclick }: SortableListItemProps) {
  const { attributes, listeners, setNodeRef, transition, transform } = useSortable({
    id: value.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Paper variant="outlined" ref={setNodeRef} style={style} {...attributes}>
      <Box display="grid" gap={2} gridTemplateColumns="auto 1fr auto auto auto auto" p={1} alignItems="center">
        {/* NOTE: Required to make the item draggable using a small portion of UI. Otherwise, other events will not be triggered. */}
        <IconButton {...listeners} tabIndex={-1} style={{ cursor: 'grab' }} size="small" disabled>
          <DragIndicatorIcon />
        </IconButton>
        <Typography>{value.title}</Typography>
        {!!value.score && <Typography>{`MpV: ${value.score}`}</Typography>}
        <Typography>{value.provider}</Typography>
        <Typography>{currencyFormatter(value.pricing.currency, value.pricing.salesPrice)}</Typography>

        <IconButton
          title="Remove"
          onClick={(e: MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            removeOnclick(value);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    </Paper>
  );
}
